import { useEffect, useRef, useState } from 'react';
import useSWR from 'swr';
import DeliveryController from '@/services/DeliveryController';
import { DELIVERY_URL } from '@/services/urls';

export const useAllDeliveries = ({ user, isMasterOrAdmin }) => {
	const [allDeliveries, setAllDeliveries] = useState([]);
	const allDeliveriesRef = useRef();

	const { data: dataDeliveries } = useSWR(
		!!user?.cityLocation && (isMasterOrAdmin || user?.cityLocation?.withDeliveryPhoneVisible)
			? DELIVERY_URL
			: false,
		() => DeliveryController.getAll(user?.cityLocation?.id),
	);

	useEffect(() => {
		if (!dataDeliveries?.deliveries) {
			return;
		}

		const deliveries = dataDeliveries.deliveries.map(it => ({
			...it,
			label: it.name,
			value: it.id,
		}));
		setAllDeliveries(deliveries.filter(d => !d.blocked));
	}, [dataDeliveries?.deliveries]);

	useEffect(() => {
		allDeliveriesRef.current = allDeliveries;
	}, [allDeliveries]);

	return { allDeliveries, setAllDeliveries, allDeliveriesRef };
};
